/* ============================================================
   Polish Gallery — falling snow over the hero (canvas).
   Loaded by sections/pg-hero.liquid when "Falling snow" is on.
   Needs no library, pauses while the hero is off screen and
   stays off for visitors who prefer reduced motion.
   ============================================================ */
(function () {
  'use strict';

  // Runs for every visitor (owner, 1 Oct 2026); the OS reduced-motion setting is not applied.

  function snow(canvas) {
    if (canvas.dataset.pgSnowOn) return;
    canvas.dataset.pgSnowOn = '1';
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    let w = 0;
    let h = 0;
    let flakes = [];
    let raf = 0;
    let last = 0;
    let visible = false;

    const flake = (y) => ({
      x: Math.random() * w,
      y: y === undefined ? Math.random() * h : y,
      r: 0.7 + Math.random() * 2.1,
      vy: 14 + Math.random() * 30,
      vx: -8 + Math.random() * 16,
      a: 0.3 + Math.random() * 0.6,
      p: Math.random() * Math.PI * 2,
    });

    function size() {
      const box = canvas.getBoundingClientRect();
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      const widthChanged = Math.abs(box.width - w) > 1;
      w = box.width;
      h = box.height;
      canvas.width = Math.round(w * dpr);
      canvas.height = Math.round(h * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      if (widthChanged || !flakes.length) {
        const count = Math.round(Math.min(140, (w * h) / 8000));
        flakes = Array.from({ length: count }, () => flake());
      }
    }

    function frame(t) {
      const dt = last ? Math.min(0.05, (t - last) / 1000) : 0.016;
      last = t;
      ctx.clearRect(0, 0, w, h);
      ctx.fillStyle = '#fff';
      for (const f of flakes) {
        f.p += dt * 1.4;
        f.y += f.vy * dt;
        f.x += (f.vx + Math.sin(f.p) * 10) * dt;
        if (f.y > h + 4) Object.assign(f, flake(-4));
        if (f.x < -4) f.x = w + 4;
        else if (f.x > w + 4) f.x = -4;
        ctx.globalAlpha = f.a;
        ctx.beginPath();
        ctx.arc(f.x, f.y, f.r, 0, Math.PI * 2);
        ctx.fill();
      }
      ctx.globalAlpha = 1;
      raf = visible ? requestAnimationFrame(frame) : 0;
    }

    function start() {
      if (raf) return;
      last = 0;
      raf = requestAnimationFrame(frame);
    }

    size();
    new IntersectionObserver(([entry]) => {
      visible = entry.isIntersecting;
      if (visible) start();
    }).observe(canvas);

    let timer;
    window.addEventListener('resize', () => {
      clearTimeout(timer);
      timer = setTimeout(size, 150);
    });
  }

  const init = () => document.querySelectorAll('[data-pg-snow]').forEach(snow);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
